/* ==========================================================================
   Robolta tiered cart offer (snippets/rb-cart-offer.liquid).
   - "Add free" puts the chosen gift in the cart (one gift, quantity 1, property _rb_gift).
   - On every render it removes gifts the cart no longer qualifies for
     (subtotal dropped, or tier changed so the gift belongs to the other list).
   Prices are reduced by Shopify automatic discounts, not by this script.
   ========================================================================== */
(() => {
  if (customElements.get('rb-cart-offer')) return;

  let busy = false;

  const root = () => ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');

  const bundledSections = () => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
    return [...new Set(sections)];
  };

  const post = async (url, payload) => {
    const res = await fetch(`${root()}${url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong');
    return data;
  };

  // Apply line changes and re-render the cart drawer / cart page the theme's way
  const update = async (updates) => {
    const cart = await post('/cart/update.js', { updates, sections: bundledSections() });
    if (window.theme && theme.pubsub) {
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'rb-cart-offer', cart });
    } else {
      window.location.reload();
    }
  };

  class RbCartOffer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.reconcile();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    get allowed() {
      return (this.dataset.allowed || '').split(',').filter(Boolean);
    }

    // [{ key, qty }]
    get giftLines() {
      return (this.dataset.giftLines || '').split(',').filter(Boolean).map((part) => {
        const i = part.lastIndexOf(':');
        return { key: part.slice(0, i), qty: Number(part.slice(i + 1)) };
      });
    }

    async reconcile() {
      const lines = this.giftLines;
      if (!lines.length || busy) return;
      const allowed = this.allowed;
      const updates = {};
      let kept = false;
      lines.forEach(({ key, qty }) => {
        const variantId = key.split(':')[0];
        if (!kept && allowed.includes(variantId)) {
          kept = true;
          if (qty !== 1) updates[key] = 1;
        } else {
          updates[key] = 0;
        }
      });
      if (!Object.keys(updates).length) return;
      busy = true;
      try { await update(updates); } catch (e) { console.error(e); } finally { busy = false; }
    }

    onClick = async (event) => {
      const btn = event.target.closest('[data-rb-gift]');
      if (!btn || busy) return;
      const err = this.querySelector('.rb-offer__err');
      busy = true;
      this.querySelectorAll('[data-rb-gift]').forEach((b) => { b.disabled = true; });
      btn.setAttribute('aria-busy', 'true');
      try {
        await post('/cart/add.js', {
          items: [{ id: Number(btn.dataset.rbGift), quantity: 1, properties: { _rb_gift: this.dataset.tier } }],
        });
        // Swap: only one gift per order
        const updates = {};
        this.giftLines.forEach(({ key }) => { updates[key] = 0; });
        await update(updates);
      } catch (e) {
        if (err) { err.textContent = e.message; err.hidden = false; }
        this.querySelectorAll('[data-rb-gift]').forEach((b) => { if (b.getAttribute('aria-pressed') !== 'true') b.disabled = false; });
      } finally {
        btn.removeAttribute('aria-busy');
        busy = false;
      }
    };
  }

  customElements.define('rb-cart-offer', RbCartOffer);
})();
